import services from './servicePages.json';
import resources from './resources.json';
import caseStudies from './caseStudies.json';
import aboutPage from './aboutPage.json';
import legalPages from './legalPages.json';

export const publicServices = services.filter((service) => service.status === 'published');
export const publicResources = resources.filter((resource) => resource.status === 'published');

export const publicCaseStudies = caseStudies.filter(
  (caseStudy) =>
    caseStudy.publicStatus === 'published' &&
    caseStudy.publicationApproved === true
);

export const localizeContentItem = (item, language = 'en') => {
  if (!item) return item;
  const localized = item.translations?.[language] || {};
  const { translations, ...base } = item;
  return {
    ...base,
    ...localized,
  };
};

export const getLocalizedPublicServices = (language = 'en') =>
  publicServices.map((service) => localizeContentItem(service, language));

export const getLocalizedPublicResources = (language = 'en') =>
  publicResources.map((resource) => localizeContentItem(resource, language));

export const getLocalizedPublicCaseStudies = (language = 'en') =>
  publicCaseStudies.map((caseStudy) => localizeContentItem(caseStudy, language));

export const getServiceBySlug = (slug) =>
  publicServices.find((service) => service.slug === slug);

export const getResourceBySlug = (slug) =>
  publicResources.find((resource) => resource.slug === slug);

export const getPublicCaseStudyBySlug = (slug) =>
  publicCaseStudies.find((caseStudy) => caseStudy.slug === slug);

export const getLocalizedServiceBySlug = (slug, language = 'en') =>
  localizeContentItem(getServiceBySlug(slug), language);

export const getLocalizedResourceBySlug = (slug, language = 'en') =>
  localizeContentItem(getResourceBySlug(slug), language);

export const getLocalizedPublicCaseStudyBySlug = (slug, language = 'en') =>
  localizeContentItem(getPublicCaseStudyBySlug(slug), language);

export const servicePath = (slug) => `/services/${slug}`;
export const resourcePath = (slug) => `/resources/${slug}`;
export const caseStudyPath = (slug) => `/work/${slug}`;

export const getRelatedServices = (slugs = [], language = 'en') =>
  slugs
    .map((slug) => getLocalizedServiceBySlug(slug, language))
    .filter(Boolean);

export const getRelatedResources = (slugs = [], language = 'en') =>
  slugs
    .map((slug) => getLocalizedResourceBySlug(slug, language))
    .filter(Boolean);

export const getNextResource = (slug, language = 'en') =>
  getLocalizedResourceBySlug(slug, language);

export const getLocalizedAboutPage = (language = 'en') =>
  localizeContentItem(aboutPage, language);

export const getLocalizedLegalPage = (pageId, language = 'en') =>
  localizeContentItem(legalPages[pageId], language);
